<span
  class="filter-item badge badge-blue mr-5"
  (click)="onSelectFilter()"
  [ngClass]="{ 'filter-item__clickable': type === 'suggested' }"
  [ngStyle]="{ 'background-color': filter.color }"
>
  {{ filter.name }}: {{ filter.query }} ({{ filter.resultCount }})
  <a *ngIf="type === 'selected'" class="fa fa-times" (click)="onRemoveFilter()"></a>
</span>
